'use strict'

mapTemplate = require '../../static_map.html.mustache'

module.exports = Backbone.View.extend
  render: (map) ->
    @$el.html mapTemplate.render {map}

    $staticMapImage = $('.static-map .static-map-image')
    $staticMapImage.attr 'src', $staticMapImage.attr('data-original')